import { publish } from '@wh/message-bus';
import { featuresConfigs } from './bootstrapper';
import { ADD_HEADER_RENDERERS, HEADER_PROPS_UPDATE_REQUESTED } from './constants';

const noop = () => {};

export const makePluginsRunner = ({
  productSource,
  vertical,
  plugins,
  productConfig,
  locale,
  deviceType,
  headerType,
  content,
  header,
  bootstrapperFeatures,
  bootstrapperConfig,
  headerRenderers,
  pluginsRegistry,
}) => {
  Object.keys(pluginsRegistry).forEach((pluginName) => {
    const pluginImplementation = pluginsRegistry[pluginName];
    pluginImplementation.beforeBootstrap = pluginImplementation.beforeBootstrap || noop;
    pluginImplementation.postBootstrap = pluginImplementation.postBootstrap || noop;
    pluginImplementation.beforeRender = pluginImplementation.beforeRender || noop;
    pluginImplementation.afterRender = pluginImplementation.afterRender || noop;
  });

  const addBootstrapperFeature = (feature, verticalConfig = {}) => {
    if (!bootstrapperFeatures.find(({ name }) => name === feature.name)) {
      bootstrapperFeatures.push(feature);
    }

    const getFeatureConfig = featuresConfigs[feature.name];

    bootstrapperConfig[feature.name] = getFeatureConfig({
      productSource,
      vertical,
      locale,
      deviceType,
      headerType,
      productConfig,
      ...verticalConfig,
    });
  };

  const updateHeaderProps = (state) => publish(HEADER_PROPS_UPDATE_REQUESTED, state);
  const addHeaderRenderers = (renderers) => publish(ADD_HEADER_RENDERERS, { renderers });

  return {
    beforeBootstrap() {
      plugins.forEach((plugin) => {
        const pluginName = plugin[0];
        const pluginImplementation = pluginsRegistry[pluginName];
        const pluginConfig = plugin[1];

        pluginImplementation.beforeBootstrap({
          config: productConfig,
          content,
          locale,
          deviceType,
          headerType,
          addBootstrapperFeature,
          params: pluginConfig,
          addHeaderRenderers,
          updateHeaderProps,
        });
      });
    },

    postBootstrap({ initializedBootstrapperFeatures }) {
      plugins.forEach((plugin) => {
        const pluginName = plugin[0];
        const pluginImplementation = pluginsRegistry[pluginName];
        const pluginConfig = plugin[1];

        pluginImplementation.postBootstrap({
          config: productConfig,
          content,
          locale,
          deviceType,
          headerType,
          bootstrapperFeatures: initializedBootstrapperFeatures,
          params: pluginConfig,
          addHeaderRenderers,
          updateHeaderProps,
        });
      });
    },

    beforeRender() {
      plugins.forEach((plugin) => {
        const pluginName = plugin[0];
        const pluginImplementation = pluginsRegistry[pluginName];
        const pluginConfig = plugin[1];

        pluginImplementation.beforeRender({
          config: productConfig,
          content,
          locale,
          deviceType,
          headerType,
          header,
          headerRenderers,
          params: pluginConfig,
          addHeaderRenderers,
          updateHeaderProps,
        });
      });
    },

    afterRender() {
      plugins.forEach((plugin) => {
        const pluginName = plugin[0];
        const pluginImplementation = pluginsRegistry[pluginName];
        const pluginConfig = plugin[1];

        pluginImplementation.afterRender({
          config: productConfig,
          content,
          locale,
          deviceType,
          headerType,
          header,
          headerRenderers,
          params: pluginConfig,
          addHeaderRenderers,
          updateHeaderProps,
        });
      });
    },
  };
};
